(function() {
    'use strict';

    angular.module("imApp").factory("productWasteService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3479,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
